import Icon from '../components/Icon.vue'

Icon.register({
  'hands-helping': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M488 192H336V248C336 287.7 303.7 320 264 320S192 287.7 192 248V126.4L127.1 165.4C107.8 176.9 96 197.8 96 220.2V267.5L16 313.7C0.7 322.5-4.6 342.1 4.3 357.4L84.3 496C93.1 511.3 112.7 516.5 128 507.7L231.4 448H368C403.3 448 432 419.3 432 384H448C465.7 384 480 369.7 480 352V288H488C501.3 288 512 277.3 512 264V216C512 202.7 501.3 192 488 192zM635.7 154.6L555.7 16C546.9 0.7 527.3-4.5 512 4.3L408.6 64H306.4C294.4 64 282.7 67.4 272.5 73.7L239 94.6C229.6 100.4 224 110.7 224 121.7V248C224 270.1 241.9 288 264 288S304 270.1 304 248V160H488C518.9 160 544 185.1 544 216V244.5L624 198.3C639.3 189.4 644.5 169.9 635.7 154.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hands-helping.js
// module id = IYTJ
// module chunks = 144